<template>
  <el-form-item label="消息通知">
    <el-radio-group v-model="innerValue">
      <el-radio :label="0">不推送</el-radio>
      <el-radio :label="1">立即推送</el-radio>
      <el-radio :label="2">开始前提醒</el-radio>
    </el-radio-group>
    <div v-if="notifyTypeTip" class="field-tip">{{ notifyTypeTip }}</div>
  </el-form-item>
</template>

<script>
export default {
  name: 'MeetingRoomNotifyTypeField',
  props: {
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    notifyTypeTip() {
      const tips = {
        0: '不向预约人及参会人发送消息通知',
        1: '预约创建成功后，立即向预约人及参会人推送通知',
        2: '在会议开始前，按「签到规则配置」页中的「开始前提醒（分钟）」推送'
      };
      return tips[this.innerValue] || '';
    }
  }
};
</script>

<style scoped>
.field-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
}
</style>
